const getStatusCodeFromGraphQLErrors = graphQLErrors => {
  if (!Array.isArray(graphQLErrors)) {
    return 500
  }

  const [graphQLError = {}] = graphQLErrors
  const { extensions = {} } = graphQLError
  const { code = 'UNKNOWN' } = extensions

  switch (code) {
    case 'FORBIDDEN':
      return 403
    case 'UNAUTHENTICATED':
      return 401
    default:
      return 404
  }
}

// Returns a boolean that determines whether or not to render the error-template.
const shouldRenderErrorTemplate = statusCode => statusCode >= 300

const getMessageFromStatusCode = (t, statusCode) => {
  switch (statusCode) {
    case 400:
      return t('common:statusCode.badRequest')
    case 401:
      return t('common:statusCode.unauthorized')
    case 403:
      return t('common:statusCode.forbidden')
    case 413:
      return t('common:statusCode.entityTooLarge')
    case 415:
      return t('common:statusCode.unsupportedMediaType')
    default:
      return t('common:statusCode.internalServerError')
  }
}

module.exports = {
  getStatusCodeFromGraphQLErrors,
  shouldRenderErrorTemplate,
  getMessageFromStatusCode,
}
